import React, {Component} from 'react';
import './App.css';
import {Field, FieldArray, reduxForm, formValueSelector} from 'redux-form';
import {connect} from 'react-redux';
import {
    Elements, injectStripe, CardElement
} from 'react-stripe-elements';
import RaisedButton from 'material-ui/RaisedButton';
import axios from 'axios'
import TextField from 'material-ui/TextField';
const selector = formValueSelector('fieldArrays');

/**
 * Created by brandonong on 23/12/17.
 */

class Billing extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            calcshipping: true,
            shippingcost: 0,
            error: undefined
        }
    }


    componentDidMount() {
        var self = this
        if (parseFloat(this.props.numberofbox) > 1 && this.props.differentaddress) {
            const shippingaddress = this.props.shippingaddress.map(country => country.country)
            axios.post(
                'https://us-central1-sonder-social.cloudfunctions.net/checkroundeddeliveryprice', {
                    countries: shippingaddress
                }
            )
                .then(response => {
                    const deliveryprice = response.data.deliveryprice;
                    self.setState({shippingcost: deliveryprice})
                    self.setState({calcshipping: false})
                })
                .catch(function (error) {
                    console.log(error)
                });
        } else {
            axios.post(
                'https://us-central1-sonder-social.cloudfunctions.net/checkroundeddeliveryprice', {
                    countries: this.props.country
                }
            )
                .then(response => {
                    const deliveryprice = response.data.deliveryprice;
                    self.setState({shippingcost: deliveryprice})
                    self.setState({calcshipping: false})
                })
                .catch(function (error) {
                    console.log(error)
                });
        }
    }

    subTotal() {
        if (this.props.shippingaddress === undefined) {
            const boxvalue = (box) => {
                if (box === "Dreamer") {
                    return 59
                } else if (box === "Courage") {
                    return 45
                } else if (box === "Intelligence") {
                    return 35
                } else if (box === "Kindness") {
                    return 29
                } else if (box === "Verve") {
                    return 55
                } else if (box === "Vulnerability") {
                    return 48
                }
            }
            return (
                parseFloat(this.props.numberofbox) * boxvalue(this.props.typeofbox)
            )
        } else {
            const priceArr = this.props.shippingaddress.map(each => {
                const box = each.typeofbox
                if (box === "Dreamer") {
                    return 59
                } else if (box === "Courage") {
                    return 45
                } else if (box === "Intelligence") {
                    return 35
                } else if (box === "Kindness") {
                    return 29
                } else if (box === "Verve") {
                    return 55
                } else if (box === "Vulnerability") {
                    return 48
                }
            })
            return (
                priceArr.reduce((a, b) => a + b, 0)
            )
        }
    }

    render() {
        const {numberofbox} = this.props
        const totalcost = parseFloat(this.state.shippingcost) + parseFloat(this.subTotal())
        return (
            <div>
                {this.state.error === undefined
                    ?
                    <div>
                        <table className="shop_table woocommerce-checkout-review-order-table" style={{margin: '0 auto'}}>
                            <thead>
                            <tr>
                                <th className="product-name">Product</th>
                                <th className="product-total">Total</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr className="cart_item">
                                <td className="product-name">
                                    Sonder Social Box
                                    <strong className="product-quantity"> ×{numberofbox}</strong>
                                </td>
                                <td className="product-total">
                        <span className="subscription-price">
                            <span className="woocommerce-Price-amount amount">
                                <span className="woocommerce-Price-currencySymbol">
                                    USD $
                                </span>
                                {this.subTotal()}
                            </span>
                        </span>
                                </td>
                            </tr>
                            </tbody>
                            <tfoot>



                            <tr className="shipping">
                                <th>Shipping</th>
                                <td data-title="Shipping">
                                    <p>USD ${parseFloat(this.state.shippingcost).toFixed(2)}</p>
                                </td>
                            </tr>


                            <tr className="order-total">
                                <th>Total</th>
                                <td>
                                    <strong>
                                        <span className="woocommerce-Price-amount amount">
                                            <span className="woocommerce-Price-currencySymbol">
                                                {this.state.calcshipping ? <span>'Calculating..'</span> : <span>USD ${totalcost}</span>}
                                            </span>
                                        </span>
                                    </strong>
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                        <RaisedButton label="Previous" primary={true}
                                      onClick={this.props.onClickPrev} style={{padding: "10px, 36px"}}
                                      buttonStyle={{borderRadius: "5px"}}/>
                        <div>
                            <Field
                                label="Any special delivery instructions?"
                                name="deliveryinstructions"
                                component={renderTextField}
                            />
                        </div>
                        <Elements>
                            <SplitForm calcshipping={this.state.calcshipping} emailaddress={this.props.emailaddress} price={totalcost} shippingcost={parseFloat(this.state.shippingcost)} oos={this.props.oos}/>
                        </Elements>
                    </div>

                    :
                    <div>
                        <div>
                            There is a problem in calculating the shipping cost,
                            please make sure all the fields in the previous sections are filled correctly.
                        </div>
                        <div>
                            {this.state.error}
                        </div>
                    </div>
                }
            </div>
        )
    }
}

const renderTextField = ({
                             input,
                             label,
                             type,
                             name,
                             placeholder,
                             meta: {touched, error},
                             ...custom
                         }) => (
    <div>
        <label for={name}>{label}</label>
        <TextField
            hintText={placeholder}
            errorText={touched && error}
            type={type}
            fullWidth={true}
            style={{border:"1px solid #e4d6cf", borderRadius:"5px", backgroundColor:"#fdfdfd", paddingLeft:"10px", transition:"border-color .15s ease-in-out,box-shadow .15s ease-in-out"}}
            underlineStyle={{borderBottom:"none"}}
            {...input}
            {...custom}
        />
    </div>
)


class _SplitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            paymentsuccess: false,
            cardnotvalidated: true,
            paymentloading: false,
            paymenterror: undefined,
            shippingaddobj: {}
        }
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(change) {
        console.log('[change]', change.complete);
        if (change.complete === true ) {
            this.setState({cardnotvalidated: false})
        }
    }

    handleSubmit = ev => {
        ev.preventDefault();
        var self = this
        this.setState({paymentloading: true})
        this.setState({paymenterror: undefined})
        if (parseFloat(this.props.numberofbox) > 1 && this.props.differentaddress) {
            for (let i = 0; i < parseFloat(this.props.shippingaddress.length); i++) {
                let shippingaddressobj = this.state.shippingaddobj
                shippingaddressobj[`shippingaddress${i}`] = ''.concat(this.props.shippingaddress[`${i}`]['recname'],' ',this.props.shippingaddress[`${i}`]['streetaddress'],' ', this.props.shippingaddress[`${i}`]['optionalstreetaddress'], ' ', this.props.shippingaddress[`${i}`]['postalcodezip'], ' ', this.props.shippingaddress[`${i}`]['towncity'], ' ', this.props.shippingaddress[`${i}`]['country'], ' ',this.props.shippingaddress[`${i}`]['typeofbox'])
                this.setState({shippingaddobj: shippingaddressobj})
            }
            let shippingaddressobj = this.state.shippingaddobj
            shippingaddressobj['numberofbox'] = this.props.numberofbox
            shippingaddressobj['phoneno'] = this.props.numberofbox
            shippingaddressobj['shippingcost'] = this.props.shippingcost
            shippingaddressobj['yourname']  = this.props.yourname
            shippingaddressobj['deliveryinstructions'] = this.props.deliveryinstructions
            this.setState({shippingaddobj: shippingaddressobj})
        }
        this.props.stripe.createToken().then(
            payload => {
                console.log(payload);
                if (parseFloat(this.props.numberofbox) > 1 && this.props.differentaddress) {
                    console.log(self.state.shippingaddobj)
                    axios.post('https://us-central1-sonder-social.cloudfunctions.net/stripepayment', {
                        token: payload.token.id,
                        email: self.props.emailaddress,
                        amount: (parseFloat(self.props.price) * 100).toFixed(0),
                        metadata: this.state.shippingaddobj
                    })
                        .then(function (response) {
                            console.log(response)
                            self.setState({paymentsuccess: true})
                            self.setState({paymentloading: false})
                        })
                        .catch(function (err) {
                            self.setState({paymenterror: err.response.data.error.message})
                            self.setState({paymentloading: false})
                        })
                } else {
                    axios.post('https://us-central1-sonder-social.cloudfunctions.net/stripepayment', {
                        token: payload.token.id,
                        email: self.props.emailaddress,
                        amount: (parseFloat(self.props.price) * 100).toFixed(0),
                        metadata: {'typeofbox': self.props.typeofbox, 'yourname': self.props.yourname,'deliveryinstructions': self.props.deliveryinstructions,'numberofbox': self.props.numberofbox, 'phoneno':self.props.phoneno, 'shippingcost':self.props.shippingcost, 'shippingaddress': self.props.streetaddress.concat(' ',self.props.optionalstreetaddress,' ',self.props.postalcodezip,' ',self.props.towncity,' ', self.props.country)},
                    })
                        .then(function (response) {
                            console.log(response)
                            self.setState({paymentsuccess: true})
                            self.setState({paymentloading: false})
                        })
                        .catch(function (err) {
                            self.setState({paymenterror: err.response.data.error.message})
                            self.setState({paymentloading: false})
                        })
                }
            }
        )
    }

    render() {
        console.log(this.state.shippingaddobj)
        console.log(this.props)
        return (
            <div id="stripe_payment">
                <div>
                    <label>
                        Card details
                        <CardElement
                            onBlur={handleBlur}
                            onChange={this.handleChange}
                            onFocus={handleFocus}
                            onReady={handleReady}
                            {...createOptions(this.props.fontSize)}
                        />
                    </label>
                    {this.state.paymentloading
                        ?
                        <div className="form-item-fadein">
                            <div className="container">
                                <strong>
                                    Please wait a moment while we validate your card details
                                </strong>
                            <div className="spinner">
                                <div className="bounce1"/>
                                <div className="bounce2"/>
                                <div className="bounce3"/>
                            </div>
                        </div>
                        </div>
                        : undefined
                    }
                    {
                        this.state.paymenterror !== undefined
                            ? <div className="error">{this.state.paymenterror}</div>
                            : undefined
                    }
                </div>
                <button id="payment_button" onClick={this.handleSubmit} disabled={this.props.calcshipping || this.state.cardnotvalidated || this.props.oos}>Pay</button>
                {this.state.paymentsuccess
                    ?
                    <div className="successpopup">
                        <div className="successpopup_inner">
                            <img src="https://www.sondersocial.com/wp-content/uploads/2017/07/sonder-social-logo-icon-600-150x150.png"/>
                            <div className="successtext">Thank you for subscribing with us!</div>
                            <div className="success-subtext">
                                We will send a confirmation email to <strong>{this.props.emailaddress} </strong>
                                shortly.<br/>
                                The email will include delivery details and subscription account
                            </div>
                            <a href="https://sondersocial.com" className="backtohomebutton">Back to home</a>
                        </div>
                    </div>
                    : undefined
                }
            </div>
        );
    }
}

let SplitForm = injectStripe(_SplitForm);


const handleBlur = () => {
    console.log('[blur]');
};

const handleClick = () => {
    console.log('[click]');
};
const handleFocus = () => {
    console.log('[focus]');
};
const handleReady = () => {
    console.log('[ready]');
};

const createOptions = (fontSize) => {
    return {
        style: {
            base: {
                fontSize,
                color: '#424770',
                letterSpacing: '0.025em',
                fontFamily: 'Source Code Pro, Menlo, monospace',
                '::placeholder': {
                    color: '#aab7c4',
                },
            },
            invalid: {
                color: '#9e2146',
            },
        },
    };
};


Billing = connect(
    state => {
        const numberofbox = selector(state, 'numberofbox');
        const differentaddress = selector(state, 'differentaddress');
        const emailaddress = selector(state, 'emailaddress')
        const shippingaddress = selector(state, 'shippingaddresses')
        const phoneno = selector(state, 'phoneno');
        const country = selector(state, 'country');
        const typeofbox = selector(state, 'typeofbox')



        return {
            numberofbox,
            differentaddress,
            emailaddress,
            phoneno,
            shippingaddress,
            country,
            typeofbox
        }
    }
)(Billing);

SplitForm = connect(
    state => {
        const numberofbox = selector(state, 'numberofbox');
        const differentaddress = selector(state, 'differentaddress');
        const emailaddress = selector(state, 'emailaddress')
        const shippingaddress = selector(state, 'shippingaddresses')
        const phoneno = selector(state, 'phoneno');
        const country = selector(state, 'country');
        const optionalstreetaddress = selector(state, 'optionalstreetaddress')
        const postalcodezip = selector(state, 'postalcodezip')
        const streetaddress = selector(state, 'streetaddress')
        const towncity = selector(state, 'towncity')
        const yourname = selector(state, 'yourname')
        const deliveryinstructions = selector(state, 'deliveryinstructions')
        const typeofbox = selector(state, 'typeofbox')



        return {
            numberofbox,
            differentaddress,
            emailaddress,
            phoneno,
            shippingaddress,
            country,
            optionalstreetaddress,
            postalcodezip,
            streetaddress,
            towncity,
            yourname,
            deliveryinstructions,
            typeofbox
        }
    }
)(SplitForm);


export default reduxForm({
    form: 'fieldArrays', // <------ same form name
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(Billing)


// WEBPACK FOOTER //
// ./src/Billing.js